import React, { useEffect, useState, Fragment } from "react"
import { Link, useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Select, { components } from 'react-select'

import { httpOk, GET, POST, PUT, FILE } from 'helpers/api'
import { uploadUrl, checkPermission } from "helpers/helpers"
import { ralToHex, RAL_LIST } from 'helpers/ral'
import DrawingModal from 'pages/main/cashbox/DrawingModal'
import { toast } from "react-toastify"

function CreateUpdate() {
  const { t } = useTranslation()
  const { id } = useParams()
  const navigate = useNavigate()

  const [data, setData] = useState({
    'name': '',
    'category_id': '',
    'product_type': 1,
    'unit_id': 1,
    'status': 1,
    'write_off_type': 1,
    'description': '',
    'quantity': '',
    'sale_price': '',
    'barcode': '',
    'fiscal_code': '',
    'fiscal_package_code': '',
    'code': '',
    'tax_category_id': '',
  })
  const [categories, setCategories] = useState([])
  const [productTypes, setProductTypes] = useState([])
  /* TUNIKOFON hisoblash tartibi (products.calc_mode). Sukut — 2 (karniz),
     ya'ni eski xulq: chizma kenglikni beradi. */
  const calcModes = [
    { id: 1, name: t('calc_mode_doska') },
    { id: 2, name: t('calc_mode_karniz') },
  ]
  const [categoriesInitial, setCategoriesInitial] = useState([])
  const [units, setUnits] = useState([])   // o'lchov birliklari (products_units EMAS)
  const [isOpen, setIsOpen] = useState(false)
  /* STANDART CHIZMA — mahsulotning xossasi (RAL kabi). Bu yerda bir marta
     chiziladi, sotuvda esa nom tanlanishi bilan O'ZI qatorga tushadi.
     Ilgari chek oynasidan yaratilardi — teskari tartib edi (2026-08-09). */
  const [drawShow, setDrawShow] = useState(false)
  const [tpl, setTpl] = useState(null)     // shu mahsulotning chizmasi


  async function createUpdate(e, saveContinue = false) {
    e.preventDefault()

    var sendData = { ...data }
    // ⚠️ `ingredients` va `units` ATAYIN yuborilmaydi (forma tozalangandan keyin).
    // Backend ikkisini ham `isset(...)` bilan tekshiradi — kelmasa mavjud qatorlarga
    // TEGMAYDI (ProductController.php:308 va :341). Bo'sh massiv yuborsak `units.*.name`
    // validatori ishga tushib saqlashni 400 bilan yiqitishi mumkin edi.
    delete sendData.ingredients
    delete sendData.units
    sendData.prices = data.prices
    sendData.error = false

    if (sendData?.sizes?.length > 0) { // Если есть размеры цены обязательные
      for (let i = 0; i < sendData?.sizes.length; i++) {
        if (sendData?.sizes[i]['price'] === '' || sendData?.sizes[i]['sale_price'] === '') {
          sendData.error = true
        }
      }
    }

    if (sendData?.modifiers?.length > 0) { // Если есть модификаторы
      sendData.bool_modifiers = 1
    }

    if (data.product_type === 2) { // Если это заготовка
      sendData.quantity = 1
    }

    var response;
    if (sendData.id) {
      response = await PUT('/products', sendData, { loader: true })
    } else {
      response = await POST('/products', sendData, { loader: true })
    }

    if (httpOk(response)) {
      if (!saveContinue) {
        navigate('/products')
      } else {
        setData({
          ...data,
          'name': '',
          'sale_price': '',
          'product_type': 1,
          'unit_id': 1,
          'status': 1,
          'write_off_type': 1,
          'description': '',
          'image': '',
          'cooking_time': '',
          'showSmiles': false,
          'sizes': [],
        })
      }
    }
  }


  function handleChange(e) {
    var dataCopy = { ...data }
    dataCopy[e.target.name] = e.target.value

    calculateCostPrice(dataCopy)
  }

  // Mahsulot TURI tanlanganda. Rulon (2) uchun narxlar 0 dan boshlanadi —
  // rulon narxi prixoddan ($/tonna) keladi, qo'lda kiritilmaydi.
  function handleSelectInProduct(option) {
    setData({
      ...data,
      'product_type': option.id,
      'price': option.id === 2 ? 0 : '',
      'sale_price': option.id === 2 ? 0 : '',
      'menu_id': '',
    })
  }

  async function fileUpload(e) {
    const file = e.target.files[0];

    if (file) {
      const imgSize = file.size / (1024 * 1024);

      if (imgSize > 25) { // Проверка, если размер больше 25 МБ
        toast.error("Размер файла не должен превышать 25 МБ.");
        return;
      }

      // Используем промис для обработки загрузки изображения
      const validateImage = () => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
              // const imgWidth = img.width;
              // const imgHeight = img.height;

              // if (imgWidth < 800 || imgHeight < 600) {
              // 	reject(new Error("Минимальный размер 800x600 px"));
              // } else {
              // resolve();
              // }
              resolve();
            };
            img.onerror = () => reject(new Error("Failed to load image"));
            img.src = event.target.result;
          };
          reader.onerror = () => reject(new Error("Failed to read file"));
          reader.readAsDataURL(file);
        });
      };

      try {
        // Ждем завершения валидации изображения
        await validateImage();

        // Если прошла валидация, формируем данные и отправляем запрос
        let formData = new FormData();
        if (data.id) formData.append("id", data.id);
        formData.append("image", file);
        formData.append("db_name", 'products');
        formData.append("column_name", 'image');
        formData.append("path", 'products');

        let response;
        if (!data.id) {
          response = await FILE('/upload-image', formData, {}, { loader: true });
        } else {
          response = await FILE(`/update-image`, formData, {}, { loader: true });
        }

        if (httpOk(response)) {
          setData({ ...data, image: response.data.url });
        }
      } catch (error) {
        toast.error(error.message);
      }
    }
  }

  /**
   * Maydon o'zgarganda state'ni yangilaydi.
   * Avval bu yerda masalliqlardan tannarx va og'irlik hisoblanardi — masalliqlar
   * 2026-07-27 da olib tashlangach o'sha blok o'chirildi (u har holda ishlamasdi:
   * hisoblangan `cost_price` backendda hech qanday ustunga yozilmasdi).
   * Funksiya nomi saqlandi — u handleChange dan chaqiriladi.
   */
  function calculateCostPrice(dataCopyFromDelete) {
    setData(dataCopyFromDelete ? dataCopyFromDelete : { ...data })
  }


  async function selectCategory(option) {
    setIsOpen(!isOpen)
    setData({ ...data, 'category_id': option?.id, 'category_name': option?.name, })
  }

  async function getData() {
    var response = await GET(`/products/${id}`, {}, { loader: true })
    if (httpOk(response)) {
      response = response.data
      setData(response)
      var responseUnits = await GET('/helper/units')
      if (httpOk(responseUnits)) {
        setUnits(responseUnits.data)
      }

      if (response) calculateCostPrice(response)
      // chizma AKSESSUAR (3) va TUNIKOFON (5) da bir xil ishlaydi
      if (response?.product_type === 3 || response?.product_type === 5) getTemplate(response.id)
    }
  }

  async function getTemplate(productId) {
    /* ⚠️ Marshrut `sec.accessory_drawing` middleware bilan yopilgan
       (routes/api.php:297). Ruxsati yo'q tenantda (12 dan 11 tasi) aksessuar
       yoki tunikofon kartochkasi ochilganda 403 qaytardi va `api.js` uni
       qizil toast qilib ekranga chiqarardi — 84 ta mahsulotda.
       Kassada bu allaqachon tuzatilgan (Cashbox.js `getAccTemplates`),
       shu yerda unutilgan edi (2026-08-12, deploy tekshiruvi topdi). */
    if (!productId || !checkPermission('sec.accessory_drawing')) { setTpl(null); return }
    const response = await GET('/accessory-templates')
    if (httpOk(response)) {
      setTpl((response.data || []).find(x => Number(x.product_id) === Number(productId)) || null)
    }
  }

  async function saveTemplate(payload) {
    const response = await POST('/accessory-templates', {
      name: data.name || t('drawing'),
      group_name: null,
      product_id: data.id,
      draw_json: payload.draw_json,
      draw_width: payload.draw_width,
      draw_png: payload.draw_png,
    }, { loader: true })
    if (httpOk(response)) {
      toast.success(t('success'))
      getTemplate(data.id)
    }
    setDrawShow(false)
  }

  async function getUnits() {
    const response = await GET('/helper/units')
    if (httpOk(response)) setUnits(response.data)
  }

  async function getCategories() {
    var response = await GET('/helper/categories')
    response = response.data

    var arr = []
    for (let i = 0; i < response.length; i++) {
      response[i]['label'] = ` ${response[i]['name']}`
      response[i].child = false;
      if (response[i].parent_id) {
        const index = response.findIndex(x => x.id === response[i].parent_id)
        response[i].child = true;
        if (response[index]?.options && response[index]?.options?.length > 0) {
          response[index].options.push(response[i])
        } else {
          response[index].options = [response[i]]
        }
      } else {
        arr.push(response[i])
      }
    }

    setCategories(arr)
    setCategoriesInitial(response)
  }

  async function getProductTypes() {
    const response = await GET('/helper/products-types')
    // Mahsulot bo'limida "Profnastil" turi aslida shakllar uchun — "Shakl" deb ko'rsatiladi (3 til)
    if (httpOk(response)) setProductTypes(response.data.map(o =>
      (/rofnastil|рофнастил/i.test(o.name || '') ? { ...o, name: t('shape') } : o)))
  }

  const GroupHead = props => {
    return (
      <div style={{
        padding: '0',
        color: data.category_id === props.data.id ? '#fff' : '#535277',
        fontWeight: 'bold',
        backgroundColor: data.category_id === props.data.id ? '#2684FF' : 'transparent',
        fontSize: '1rem'
      }}
        onClick={() => selectCategory(props.data)}>
        <components.Option {...props} />
      </div>
    );
  };

  const Option = props => {
    return (
      <div style={{
        padding: props.data.child ? '0 0 0 20px' : '0',
        color: '#535277',
        fontWeight: props.data.parent_id === 0 ? 'bold' : 'normal',
        fontSize: '.9rem'
      }}>
        <components.Option {...props} />
      </div>
    );
  };

  useEffect(() => {
    if (id) getData()
    if (!id) getUnits()
    getCategories()
    getProductTypes()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="page-header d-flex mb-2">
        <div className="d-flex">
          <h4 className="vertical-center">
            {t('product')}
          </h4>
          <div className="vertical-center mt-1">
            <i className="uil uil-angle-double-right fz-20"></i>
          </div>
          <div className="vertical-center mt-1">
            {!id ?
              <h6>{t('create')}</h6>
              :
              <h6>{t('edit')}</h6>
            }
          </div>
          {id &&
            <Fragment>
              <div className="vertical-center mt-1">
                <i className="uil uil-angle-double-right fz-20"></i>
              </div>
              <div className="vertical-center mt-1">
                {data.pos_name}
              </div>
            </Fragment>
          }
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <form autoComplete="off">
            {/* «Masalliqlar» tabi va «Qadoqlash» paneli 2026-07-27 da OLIB TASHLANDI (user qarori).
                Dalil: masalliqlar — asprofiluz da 0 qator va uch iste'molchisi ham izohga olingan
                (cheques_ingredients ga oxirgi yozuv 2026-01-07); qadoqlash — butun bazada 1 ta
                sinov qatori, prixoddagi selecti kommentda, `packaging_id` hech qachon yozilmagan.
                Jadvallar O'CHIRILMADI — faqat forma tozalandi. */}
            <div className="row mb-5">
              <div className="col-md-8">
                <div className="flex-gap10 mb-2">
                  <div className="con-upload">
                    <div className="con-img-upload">
                      {data.image &&
                        <div className="img-upload">
                          <button type="button" className="btn-x-file" onClick={() => setData({ ...data, 'image': '' })}>
                            <i className="uil-times"></i>
                          </button>
                          <img src={`${uploadUrl}/products/${data.image}`}
                            style={{ maxWidth: 'none', maxHeight: '100%' }} alt={data.image} />
                        </div>
                      }
                      {!data.image &&
                        <div className="con-input-upload">
                          <input type="file" accept=".png, .jpg, .jpeg" onChange={(e) => fileUpload(e)} />
                          <span className="text-input fz14">
                            {t('image2')}
                          </span>
                        </div>
                      }
                    </div>
                  </div>

                  <div className="w-100">
                    <div className="form-group">
                      <label>{t("name2")}<span className="required-mark">*</span></label>
                      <div>
                        <input type="text" className="form-control" name="name" autoFocus
                          value={data.name ?? ''}
                          onChange={(e) => setData({ ...data, 'name': e.target.value })} />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>{t('type')}<span className="required-mark">*</span></label>
                      <Select
                        isDisabled={data.id}
                        options={productTypes}
                        value={productTypes.find(option => option.id === data.product_type)}
                        onChange={(option) => handleSelectInProduct(option)}
                        placeholder=""
                        noOptionsMessage={() => t('list_empty')}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                      />
                    </div>

                    <div className="form-group">
                      <label>{t('unit')}<span className="required-mark">*</span></label>
                      <Select
                        options={units}
                        value={units.find(option => option.id === data.unit_id)}
                        onChange={(option) => setData({ ...data, 'unit_id': option.id })}
                        placeholder=""
                        noOptionsMessage={() => t('list_empty')}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                      />
                    </div>

                    {/* KATEGORIYA — FAQAT RULON (tur 2). Bazada tasdiqlangan: rulon 110/110
                        to'ldirilgan, qolgan turlarda 194 dan 0. Kategoriya kassada rulonni
                        guruhlash uchun ishlatiladi (HelperController :470-471, :583-596) va
                        rulon narxlari/foyda hisobotlarida filtr bo'ladi. */}
                    <div className="form-group w-100">
                      <label>{t('category')}</label>
                      <Select
                        components={{ GroupHeading: GroupHead, Option }}
                        isClearable
                        isDisabled={data.product_type !== 2}
                        // isSearchable={false}
                        onMenuOpen={() => setIsOpen(true)}
                        onMenuClose={() => setIsOpen(false)}
                        onBlur={() => setIsOpen(false)}
                        menuIsOpen={isOpen}
                        classNamePrefix='react-select'
                        options={categories}
                        value={categoriesInitial.find(option => option.id === data.category_id)}
                        onChange={(option) => selectCategory(option)}
                        placeholder={t('categories')}
                        noOptionsMessage={() => t('list_empty')}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                      />
                    </div>
                  </div>

                </div>

                {/* ⚠️ YULDUZCHALAR OLIB TASHLANDI: backend validatori faqat name / product_type /
                    unit_id ni talab qiladi (ProductController.php:177-184). Bu to'rt maydonda
                    «majburiy» yulduzcha turgan, lekin maydonning o'zi kulrang edi — foydalanuvchi
                    to'ldirishi kerak deb o'ylab, to'ldira olmasdi.

                    Har maydon FAQAT o'zi ishlatiladigan turda faol (bazada tasdiqlangan):
                      Uzunlik/Kengligi — Aksessuar(3) 70/70, Tunikofon(5) 30/30, qolgan turlarda 0
                      Ustama           — Aksessuar 70/70, Tunikofon 27/29, qolgan 0
                                          (Cashbox.js:744-752 `price + markup` FAQAT tur 3/5 ichida)
                      Foiz             — FAQAT Shakl(4): Cherepitsa 8% (Venutcia + Kaskad).
                                          Ombordan ayirishda `metr + %` bo'lib ishlatiladi
                                          (ChequeController :3166, :3771, :4012) — 537 chek qatori
                                          shunga bog'liq, shu sababli OCHIQ qoldirildi. */}
                <div className="flex-gap10">
                  <div className="form-group w-100">
                    <label>{t('length')}</label>
                    <input type="number" className="form-control" name="length"
                      disabled={!(data.product_type === 3 || data.product_type === 5)}
                      value={data.length ?? ''}
                      onChange={(e) => handleChange(e)} />
                  </div>
                  <div className="form-group w-100">
                    <label>{t('width')}</label>
                    <input type="number" className="form-control" name="width"
                      disabled={!(data.product_type === 3 || data.product_type === 5)}
                      value={data.width ?? ''}
                      onChange={(e) => handleChange(e)} />
                  </div>
                  {/* USTAMA — Aksessuar(3), SHAKL(4) va Tunikofon(5).
                      ⚠️ Tur 4 QAYTA OCHILDI (2026-07-28): «Tayyorlash» hujjati aynan tur 4 uchun
                      `sale_price = cost_price + markup` hisoblaydi
                      (documentsPreparation/CreateUpdate.js:212-213). Yopib qo'yilsa yangi shakl
                      yaratganda markup NULL bo'lib qolardi va tayyorlangan shaklning sotuv
                      narxi tannarxga TENG chiqardi (marja 0).
                      Avvalgi qaror faqat asprofiluz ma'lumotiga tayangan edi (12 shaklda markup 0),
                      lekin `maxprof` da 2/2 shaklda markup = 10 000 — SaaS'da bitta tenant
                      qoidaga asos bo'lmaydi. */}
                  <div className="form-group w-100">
                    <label>{t('markup')}</label>
                    <input type="number" className="form-control" name="markup"
                      disabled={!(data.product_type === 3 || data.product_type === 4 || data.product_type === 5)}
                      value={data.markup ?? ''}
                      onChange={(e) => handleChange(e)} />
                    {/* Ustama BIRLIGI turga qarab boshqacha — buni aytib turmasa
                        raqam noto'g'ri joyga yoziladi (2026-08-11). */}
                    {data.product_type === 5 &&
                      <small className="text-muted">{t('markup_hint_kv')}</small>}
                    {data.product_type === 3 &&
                      <small className="text-muted">{t('markup_hint_roll')}</small>}
                  </div>
                  {/* RULON RANGI — chizma oynasidagi 3D shu rangda ko'rsatiladi.
                      Faqat rulonda (tur 2) ma'noga ega. */}
                  <div className="form-group w-100">
                    <label>
                      {t('ral_colour')}
                      {ralToHex(data.ral_code) &&
                        <span className="ms-2 d-inline-block align-middle" style={{
                          width: '16px', height: '16px', borderRadius: '3px',
                          border: '1px solid #adb5bd', background: ralToHex(data.ral_code),
                        }} />}
                    </label>
                    <input type="text" className="form-control" name="ral_code"
                      list="ral-list" placeholder="RAL6005"
                      disabled={data.product_type !== 2}
                      value={data.ral_code ?? ''}
                      onChange={(e) => handleChange(e)} />
                    <datalist id="ral-list">
                      {RAL_LIST.map(c => <option key={c} value={c} />)}
                    </datalist>
                  </div>
                  {/* NOSTANDART AKSESSUAR — mijozning o'z shakli.
                      Belgilansa: chekda shu nom tanlanganda chizma oynasi O'ZI ochiladi,
                      rulon/hajm/soni ham o'sha oynada yoziladi, narx CHIZMADAN chiqadi.
                      Belgilanmasa: standart — narx shu yerdagi «Kenglik» dan, chizma
                      biriktirilsa faqat ustaga topshiriq bo'lib qoladi, narxga tegmaydi.
                      ⚠️ Nomdan aniqlab bo'lmaydi: «(No/S)» yozuvi faqat bitta tenantda bor.
                      ⚠️ Chizma moduli FAQAT `full` tarifda — ruxsat yo'q tenantда galochka
                         umuman ko'rinmaydi (`sec.accessory_drawing`). */}
                  {(data.product_type === 3 || data.product_type === 5) && checkPermission('sec.accessory_drawing') && (
                    <div className="form-group w-100">
                      <label className="d-flex align-items-center gap-2" style={{ cursor: 'pointer' }}>
                        <input type="checkbox" className="form-check-input mt-0" name="needs_drawing"
                          checked={!!data.needs_drawing}
                          onChange={(e) => handleChange({ target: { name: 'needs_drawing', value: e.target.checked } })} />
                        {t('needs_drawing')}
                      </label>
                      <small className="text-muted">{t('needs_drawing_hint')}</small>
                    </div>
                  )}

                  {/* ═══ CHEREPITSA (2026-08-27, egasining talabi) ═══
                      Belgilangan mahsulotda kassa BOSHI (5/8 sm) va SHAG
                      (35/38/39 sm) maydonlarini ochadi — press qadami chekda
                      ko'rinadi, usta adashmaydi. Faqat profnastil (tur 4). */}
                  {data.product_type === 4 && (
                    <div className="form-group w-100">
                      <label className="d-flex align-items-center gap-2" style={{ cursor: 'pointer' }}>
                        <input type="checkbox" className="form-check-input mt-0" name="is_tile"
                          checked={!!data.is_tile}
                          onChange={(e) => handleChange({ target: { name: 'is_tile', value: e.target.checked } })} />
                        {t('tile_product_flag')}
                      </label>
                      <small className="text-muted">{t('tile_product_flag_hint')}</small>
                    </div>
                  )}

                  {/* ═══ TUNIKOFON: HISOBLASH TARTIBI ═══
                      Tunikofon ichida ikki xil mahsulot bor va ular boshqacha
                      hisoblanadi. Bu «стандарт/ностандарт» dan MUSTAQIL savol:
                        · DOSKA  — chizma доскaнинг УЗУНЛИГИНИ beradi (Ҳажми),
                                   kenglik esa listni 1/2/3/4 ga bo'lishdan.
                        · КАРНИЗ — aksessuardagidek: chizma КЕНГЛИКНИ (sarf) beradi,
                                   uzunlik qo'lda yoziladi.
                      ⚠️ Nomdan aniqlab BO'LMAYDI: «Karniz» ikkala turda ham bor,
                         boshqa tenantda nomlar butunlay boshqacha (2026-08-11). */}
                  {data.product_type === 5 && (
                    <div className="form-group w-100">
                      <label>{t('calc_mode')}</label>
                      <Select
                        options={calcModes}
                        value={calcModes.find(o => o.id === (Number(data.calc_mode) || 2))}
                        onChange={(o) => handleChange({ target: { name: 'calc_mode', value: o ? o.id : null } })}
                        placeholder=""
                        noOptionsMessage={() => t('list_empty')}
                        getOptionLabel={(o) => o.name}
                        getOptionValue={(o) => o.id}
                      />
                      <small className="text-muted">
                        {(Number(data.calc_mode) || 2) === 1 ? t('calc_mode_hint_doska') : t('calc_mode_hint_karniz')}
                      </small>
                    </div>
                  )}

                  <div className="form-group w-100">
                    <label>{t('percentage')}</label>
                    <input type="number" className="form-control" name="percentage"
                      disabled={!(data.product_type === 4)}
                      value={data.percentage ?? ''}
                      onChange={(e) => handleChange(e)} />
                  </div>
                  {data.product_type === 4 && (
                    <div className="form-group w-100">
                      <label>{t('speed_per_min')}</label>
                      <input type="number" step="0.01" className="form-control" name="speed_per_min"
                        value={data.speed_per_min ?? ''}
                        onChange={(e) => handleChange(e)}
                        placeholder="1 daqiqada necha metr" />
                    </div>
                  )}
                </div>

                {/* ═══ STANDART CHIZMA ═══
                    Chizma mahsulotning xossasi: bu yerda BIR MARTA chiziladi,
                    sotuvda esa nom tanlanishi bilan o'zi qatorga tushadi.
                    ⚠️ Faqat SAQLANGAN mahsulotda — chizma `product_id` ga bog'lanadi.
                    ⚠️ NOSTANDARTDA KO'RSATILMAYDI: u yerda chizma HAR CHEKDA
                       yangidan chiziladi (nom tanlanishi bilan oyna o'zi ochiladi),
                       shablon esa hech qachon ishlatilmasdi — faqat chalkashtirardi
                       (2026-08-11, foydalanuvchi topdi). */}
                {(data.product_type === 3 || data.product_type === 5) && !data.needs_drawing && checkPermission('sec.accessory_drawing') && (
                  <div className="form-group w-100 mt-2">
                    <label>{t('drawing')}</label>
                    <div className="border rounded p-3 d-flex align-items-center gap-3"
                      style={{ background: '#fbfbfd' }}>
                      {tpl?.draw_png
                        ? <img src={tpl.draw_png} alt="" style={{
                          width: '110px', height: '70px', objectFit: 'contain',
                          border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff',
                        }} />
                        : <div className="text-muted d-flex align-items-center justify-content-center"
                          style={{ width: '110px', height: '70px', border: '1px dashed #ced4da', borderRadius: '4px' }}>—</div>}
                      <div>
                        <button type="button" className="btn btn-sm btn-outline-primary"
                          disabled={!data.id}
                          onClick={() => setDrawShow(true)}>
                          ✎ {tpl ? t('edit') : t('draw')}
                        </button>
                        <div className="text-muted mt-2" style={{ fontSize: '12px', maxWidth: '420px' }}>
                          {!data.id
                            ? t('drawing_after_save')
                            : tpl
                              ? `${t('stretch_out')}: ${tpl.draw_json?.blank ?? '—'} ${t('mm')}`
                              : t('drawing_product_hint')}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* ═══ USTAMA JADVALI — faqat nostandart aksessuarda ═══
                    Nima uchun kerak: yuqoridagi «Ustama» RULON metriga yoziladi va
                    bo'laklarga BO'LINADI — 10 000 qo'ysangiz 5b ga atigi 2 000 tushadi.
                    Amalda esa 25 sm lik bo'lakka 4 000 dan olinadi. Standartda buni
                    har mahsulotga alohida raqam qo'yib hal qilishgan; nostandartda
                    esa bitta mahsulot — razvyortka har safar boshqa.
                    Bu yerdagi qiymat — 1 METR MAHSULOTGA xizmat haqi.
                    ⚠️ `flex-gap10` ICHIDA EMAS: u `display:flex` (o'ralmaydi), jadval
                       ichiga qo'yilsa tor ustunga siqilib qolardi (2026-08-09). */}
                {/* ⚠️ FAQAT AKSESSUAR (tur 3). Tunikofonda «bo'lak» degan tushuncha
                    UMUMAN YO'Q: u kv.metrda sotiladi va narx rulonning sotuv narxidan
                    chiqadi, kenglik esa summaga o'zi tushadi. Shuning uchun bo'lak
                    soniga qarab xizmat haqi ma'nosiz — 2026-08-11 da tur 5 shu
                    jadvaldan olib tashlandi (foydalanuvchi: «bo'lib degan narsa yo'q»). */}
                {data.product_type === 3 && data.needs_drawing && checkPermission('sec.accessory_drawing') && (
                  <div className="form-group w-100 mt-2">
                    <label>{t('markup_tiers')}</label>
                    <div className="border rounded p-3" style={{ background: '#fbfbfd' }}>
                      <div className="text-muted mb-3" style={{ fontSize: '12.5px' }}>
                        {t('markup_tiers_hint')}
                      </div>
                      {/* 1b…18b — SaaS: har tenant o'z ustamasini qo'yadi, shuning uchun
                          to'liq narvon beriladi. Hammasini to'ldirish SHART EMAS —
                          bo'sh qatorga eng yaqin to'ldirilgani ishlatiladi. */}
                      <div className="d-flex flex-wrap gap-3">
                        {Array.from({ length: 18 }, (_, k) => k + 1).map(n => (
                          <div key={n} className="d-flex align-items-center gap-2">
                            <span className="text-muted fw-bold" style={{ fontSize: '12.5px', width: '30px' }}>{n}b</span>
                            <input type="number" className="form-control form-control-sm text-end"
                              style={{ width: '120px' }} placeholder="—"
                              value={(data.markup_tiers && data.markup_tiers[n]) ?? ''}
                              onChange={(e) => {
                                const tiers = { ...(data.markup_tiers || {}) }
                                if (e.target.value === '') delete tiers[n]
                                else tiers[n] = Number(e.target.value)
                                handleChange({ target: { name: 'markup_tiers', value: tiers } })
                              }} />
                          </div>
                        ))}
                      </div>
                      {/* Jadval butunlay bo'sh bo'lsa eski «Ustama» ishlaydi — u ham
                          bo'sh bo'lsa xizmat haqi UMUMAN olinmaydi. Shuni aytib turamiz. */}
                      {!Object.keys(data.markup_tiers || {}).some(k => Number(data.markup_tiers[k]) > 0)
                        && !(Number(data.markup) > 0) && (
                        <div className="text-danger mt-3" style={{ fontSize: '12.5px' }}>
                          ⚠ {t('markup_tiers_empty')}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* <div className="flex-gap10"> n
									<div className="form-group w-100">
										<label>{t('price')}<span className="required-mark">*</span></label>
										<input type="number" className="form-control" name="price"
											value={data.price ?? ''}
											onChange={(e) => handleChange(e)} />
									</div>
									<div className="form-group w-100">
										<label>{t('wholesale_price')}<span className="required-mark">*</span></label>
										<input type="number" className="form-control" name="wholesale_price"
											value={data.wholesale_price ?? ''}
											onChange={(e) => handleChange(e)} />
									</div>
									<div className="form-group w-100">
										<label>{t('sale_price')}<span className="required-mark">*</span></label>
										<input type="number" className="form-control" name="sale_price"
											value={data.sale_price ?? ''}
											onChange={(e) => handleChange(e)} />
									</div>
								</div> */}

                <div className="form-group w-100">
                  <label>{t("description")}</label>
                  <textarea className="form-control" name="description"
                    value={data.description ?? ''}
                    onChange={(e) => setData({ ...data, 'description': e.target.value })} />
                </div>
                <hr />
                <div className="d-flex justify-content-between">
                  <p className="fw-600 vertical-center">{t('on_sale')}</p>
                  <div className="form-check form-switch form-switch-lg">
                    <input type="checkbox" className="form-check-input" name="status"
                      checked={data?.status}
                      onChange={(e) => setData({ ...data, 'status': e.target.checked })}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="btn-wrapper gap-2">
              <Link className="btn btn-warning btn-rounded btn-wide" to="/products">
                {t('cancel')}
              </Link>
              {!data.id &&
                <button type="button" className="btn btn-secondary btn-rounded btn-wide"
                  onClick={(e) => createUpdate(e, true)}>
                  {t('save')}
                  <i className="uil uil-arrow-right"></i>
                </button>
              }
              <button type="button" className="btn btn-primary btn-rounded btn-wide"
                onClick={(e) => createUpdate(e)}>
                {t('save')}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* STANDART CHIZMA OYNASI — shablon rejimi: rulon, hajm, soni va narx yo'q,
          faqat shaklning o'zi. Rulon eni sifatida katalogdagi «Узунлик» olinadi. */}
      <DrawingModal
        show={drawShow}
        onHide={() => setDrawShow(false)}
        onSave={saveTemplate}
        initial={tpl?.draw_json || null}
        rollWidthM={Number(data.length) || 1.25}
        rollPriceSom={0} markup={0}
        elementQuantity={0} quantity={0}
        rollRal={null} rollName={null}
        productId={data.id} rollProductId={null}
        rollCats={[]} needsDrawing={false} markupTiers={null}
        rollSel={null} onRollSel={() => {}} onOpenRollPicker={() => {}}
        templateMode={true} />
    </>
  )
}

export default CreateUpdate